const hour = 'hour';
const day = 'day';

export const TimeUnits = Object.freeze({
    [hour]: 0,
    [day]: 1,
});

export const TimeUnitKeys = Object.freeze({
    0: hour,
    1: day,
});
